<template>
  <f7-page :page-content="false">
    <f7-navbar title="Planificaciones" :back-link="$t('atras')"></f7-navbar>
    <f7-page-content class="full-height">
      <r-dynamic-list
        ref="rlist"
        :dbAdapter="Planificacion"
        :tableCode="'PLANIFICACION'"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        :massiveActions="false"
        :controlsWidth="80"
      >
        <template v-slot:optionsColumn="{item}">
          <f7-link
            v-tooltip="$t('common.ver') + ' Planificación'"
            icon-f7="eye"
            color="green"
            :href="`/planificacion/view/${item.id}/`"
          ></f7-link>
        </template>
      </r-dynamic-list>
    </f7-page-content>
  </f7-page>
</template>
<script>
import rDynamicList from "./../../components/rDynamicList.vue";
import Planificacion from "./../../js/db/Planificacion.js";

export default {
  components: {
    rDynamicList
  },
  data() {
    return {
      Planificacion
    };
  }
};
</script>
